/************************
 * EVENTOS PARA EQUIPOS *
 ************************/

/**
 * @author Rigoberto Sanchez
 * @description Evento para seleccionar el equipo para analizar
 * @param {Number} team_id Identificador del equipo
 */
export function analisisDeEquipo(team_id) {
  dataLayer.push({
    event: 'analisis_de_equipo',
    team_id,
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Evento para inicar la seleccion de analisis de posesion del equipo y temporada seleccionados
 * @param {Number} season_id Identificador de la temporada
 * @param {Number} team_id Identificador del equipo
 */
export function analisisDeEquipoPosesion(season_id, team_id) {
  dataLayer.push({
    event: 'analisis_de_equipo_posesion',
    season_id,
    team_id,
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Evento para inicar la seleccion de analisis de ofensivo del equipo y temporada seleccionados
 * @param {Number} season_id Identificador de la temporada
 * @param {Number} team_id Identificador del equipo
 */
export function analisisDeEquipoOfensivo(season_id, team_id) {
  dataLayer.push({
    event: 'analisis_de_equipo_ofensivo',
    season_id,
    team_id,
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Evento para inicar la seleccion de analisis de ofensivo del equipo y temporada seleccionados
 * @param {Number} season_id Identificador de la temporada
 * @param {Number} team_id Identificador del equipo
 */
export function analisisDeEquipoDefensivo(season_id, team_id) {
  dataLayer.push({
    event: 'analisis_de_equipo_defensivo',
    season_id,
    team_id,
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Envia la notificacion de que se uso el filtro en movil
 * @param {Number} season_id
 * @param {Number} team_id
 * @param {String} view
 */
export function analisisDeEquipoFiltros(season_id, team_id, view) {
  dataLayer.push({
    event: 'analisis_de_equipo_filtros',
    season_id,
    team_id,
    view,
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Envia el evento de que cambio el selector de filtros de la "temporada"
 * @param {Number} season_id
 * @param {Number} team_id
 * @param {String} view
 */
export function analisisDeEquipoFiltroTemporada(season_id, team_id, view) {
  dataLayer.push({
    event: 'analisis_de_equipo_filtro_temporada',
    season_id,
    team_id,
    view,
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Envia el evento de que se cambio el selector de filtros de "estadistica"
 * @param {*} season_id
 * @param {*} team_id
 * @param {*} view
 */
export function analisisDeEquipoFiltroEstadistica(season_id, team_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_equipo_filtro_estadistica',
    season_id,
    team_id,
    view,
    value,
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Envia el evento de que se cambio el selector de "jugado como"
 * @param {Number} season_id Identificador de la temporada
 * @param {Number} team_id Identificador del equipo
 * @param {String} view Vista desde la cual se hace el cambio (totales/promedio por partido)
 * @param {String} value Valor que se cambia la vista (todos/local/visitante)
 */
export function analisisDeEquipoFiltroJugadoComo(season_id, team_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_equipo_filtro_jugado_como',
    season_id,
    team_id,
    view,
    value,
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Envia el evento de que se cambiaron los checkbox de "resultados"
 * @param {Number} season_id Identificador de la temporada
 * @param {Number} team_id Identificador del equipo
 * @param {String} view nombre de la vista
 * @param {*} value
 */
export function analisisDeEquipoFiltroPorResultado(season_id, team_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_equipo_filtro_por_resultado',
    season_id,
    team_id,
    view,
    value,
  });
}

/**
 * @author Rigoberto Sanchez
 * @description Envia el evento de que se cambiaron los filtros de "tiempo"
 * @param {Number} season_id Identificador de la temporada
 * @param {Number} team_id Identificador del equipo
 * @param {String} view nombre de la vista
 * @param {*} value
 */
export function analisisDeEquipoFiltroPorTiempo(season_id, team_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_equipo_filtro_por_tiempo',
    season_id,
    team_id,
    view,
    value,
  });
}

export function analisisDeEquipoSeccionVista(season_id, team_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_equipo_seccion_vista',
    season_id,
    team_id,
    view,
    value,
  });
}

export function analisisDeEquipoCategoriasDeTabla(season_id, team_id, category, view, value) {
  dataLayer.push({
    event: 'analisis_de_equipo_categorias_de_tabla',
    season_id,
    team_id,
    category,
    view,
    value,
  });
}

export function analisisDeEquipoDetallesCategoria(season_id, team_id, view, category) {
  dataLayer.push({
    event: 'analisis_de_equipo_detalles_categoria',
    season_id,
    team_id,
    category,
    view,
  });
}

export function analisisDeEquipoDetallesSubcategoria(season_id, team_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_equipo_detalles_subcategoria',
    season_id,
    team_id,
    view,
    value,
  });
}

export function analisisDeEquipoTablaGrafica(season_id, team_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_equipo_tabla_o_grafica',
    season_id,
    team_id,
    view,
    value,
  });
}

export function analisisDeEquipoVistaPizarra2D3D(season_id, team_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_equipo_vista_pizarra_2d_o_3d',
    season_id,
    team_id,
    view,
    value,
  });
}

export function analisisDeEquipoSeleccionTodoPizarra(season_id, team_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_equipo_selecciontodo_pizarra',
    season_id,
    team_id,
    view,
    value,
  });
}

export function analisisDeEquiposCategoriaDePizarra(season_id, team_id, view, category, value) {
  dataLayer.push({
    event: 'analisis_de_equipo_categoria_de_pizarra',
    season_id,
    team_id,
    view,
    category,
    value,
  });
}

export function analisisDeEquipoCategoriasPorteria(season_id, team_id, view, category, value) {
  dataLayer.push({
    event: 'analisis_de_equipo_categorias_porteria',
    season_id,
    team_id,
    view,
    category,
    value,
  });
}
